import { render, staticRenderFns } from "./privateUsedCarConfig.vue?vue&type=template&id=32e3ad4c&scoped=true"
import script from "./privateUsedCarConfig.vue?vue&type=script&lang=js"
export * from "./privateUsedCarConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3ad4c",
  null
  
)

export default component.exports